import * as Yup from 'yup';
import { CampaignData, CampaignMainInfoUpdateData } from '../models/campaign.ts';
import { PurchaseInputData } from '../models/purchase.ts';

export type CampaignAsset = Pick<PurchaseInputData, 'authorName' | 'assetName' | 'assetLink' | 'releaseDate'>;

export type UpdateCampaignMainInfoDto = CampaignMainInfoUpdateData & {
    campaignId: string,
};

// deno-lint-ignore no-namespace
export namespace UpdateCampaignMainInfoDto {
    export function createValidation(): Yup.ObjectSchema<UpdateCampaignMainInfoDto> {
        return Yup.object({
            campaignId: Yup.string().required('Product is required'),
            name: Yup.string().required('Name is required'),
            email: Yup.string().required('Email is required'),
            guaranteedStream: Yup.number().required('Guaranteed stream is required'),
        }).noUnknown();
    }
}

export type UpdateCampaignMainInfoResponseDto = {
    campaign: CampaignData;
};
